export default __webpack_public_path__ + "static/media/step3.1cf452b2.webp";